import { useEffect, useState } from 'react';
import type { MenuCategory, MenuItem } from '@cracked-mug/shared';
import { fetchMenu } from '../services/menuApi';

interface MenuState {
  categories: MenuCategory[];
  items: MenuItem[];
  isLoading: boolean;
  error: string | null;
}

/**
 * Loads the menu once on mount. Returns the standard
 * `{ data, isLoading, error }`-shaped state required by the spec.
 */
export function useMenu(): MenuState {
  const [state, setState] = useState<MenuState>({
    categories: [],
    items: [],
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    fetchMenu()
      .then((data) => {
        if (cancelled) return;
        setState({
          categories: data.categories,
          items: data.items,
          isLoading: false,
          error: null,
        });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setState({
          categories: [],
          items: [],
          isLoading: false,
          error: err instanceof Error ? err.message : 'Failed to load menu',
        });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
